import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

import {
  ButtonContainer,
  Container,
  LeftContainer,
} from "../../../Components/StyledComponents/NftMarketStyledComponents";

import { Text, TextWrapper } from "./NftMarketStyle";
import { NavLink } from "react-router-dom";
import "../../NftMarket/NftMarketPage/Index.css";

import { init } from "../../../config/provider";

const Root = styled.div``;

const NftMarketHomepage = ({ allContractDetails, setAllContractDetails }) => {
  // console.log("allcontractDetails", allContractDetails,)
  const [serchValue, setSearchValue] = useState("");
  const [userLoggedIn, setUserLoggedIn] = useState(false);
  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const [initInProgress, setInitInProgress] = useState(false);
  const navigation = useNavigate();

  const CheckUserHandler = () => {
    const checkLoginData = init();
    if (!checkLoginData) {
      setShowLoginPopup(true);
    } else {
      navigation("/mynfts");
    }
  };

  // useEffect(() => {
  //   initUserSession();
  // }, []);

  // const initUserSession = async () => {
  //   setInitInProgress(true);
  //   try {
  //     const user = await init();
  //     if (user) {
  //       setUserLoggedIn(true);
  //       setInitInProgress(false);
  //     } else {
  //       setShowLoginPopup(true);
  //       setInitInProgress(false);
  //     }
  //   } catch (error) {
  //     console.error("Initialization error:", error);
  //     setInitInProgress(false);
  //   }
  // };

  // const handleMyNFTsClick = () => {
  //   if (userLoggedIn) {
  //     navigation("/mynfts");
  //   } else {
  //     setShowLoginPopup(true);
  //   }
  // };

  return (
    <Root>
      <Container>
        {/* <HeaderComponent /> */}
        <ButtonContainer>
          <LeftContainer>
            <TextWrapper>
              {/* <Text>
                {" "}
                <NavLink
                  to="/nftMarket"
                  className={({ isActive }) =>
                    isActive ? "link-active" : "link"
                  }
                >
                  Home
                </NavLink>
              </Text> */}

              <Text>
                <NavLink
                  to="/nftMarket"
                  className={({ isActive }) =>
                    isActive ? "link-active" : "link"
                  }
                >
                  Home
                </NavLink>
              </Text>
              <Text>
                <NavLink
                  to="/nftcategories/0x7eb272ac9b9fec60c5a7921ccc075152a961111c"
                  className={({ isActive }) =>
                    isActive ? "link-active" : "link"
                  }
                  // className="link"
                >
                  Characters
                </NavLink>
              </Text>
              <Text>
                <NavLink
                  to="/nftcategories/0x8fc3dec6148a9924870f205617c9c26b3010243e"
                  className={({ isActive }) =>
                    isActive ? "link-active" : "link"
                  }
                >
                  Shootable
                </NavLink>
              </Text>
              <Text>
                <NavLink
                  to="/nftcategories/0x6ab30d4c7de4a24cbe84eb310fd164b64b06b532"
                  className={({ isActive }) =>
                    isActive ? "link-active" : "link"
                  }
                  // className="link"
                >
                  Melee
                </NavLink>
              </Text>

              {/* <Text>
                <NavLink
                  to="/nftcategories/0x8fc3dec6148a9924870f205617c9c26b3010243e"
                  className={({ isActive }) =>
                    isActive ? "link-active" : "link"
                  }
                  className="link"
                >
                  Characters
                </NavLink>{" "}
              </Text> */}
              {/* <Text>
                {" "}
                <NavLink
                  to="/nftcategories/0x8a41c16ed29205383cf920b7bc50846852945202"
                  className={({ isActive }) =>
                    isActive ? "link-active" : "link"
                  }
                >
                  Melee
                </NavLink>{" "}
              </Text> */}

              {/* <Text>
                {" "}
                <NavLink
                  to="/nftcategories/0x7eb272ac9b9fec60c5a7921ccc075152a961111c"
                  className={({ isActive }) =>
                    isActive ? "link-active" : "link"
                  }
                >
                  Characters
                </NavLink>{" "}
              </Text> */}

              {/* <Text>
                {" "}
                <NavLink
                  to="/nftcategories/0xeef62f2d350f6fce56118a077ba0a18c2b730d83"
                  className={({ isActive }) =>
                    isActive ? "link-active" : "link"
                  }
                >
                  Vehicles
                </NavLink>{" "}
              </Text> */}

              {/* <Text>
                {" "}
                <NavLink
                  to="/auctionnfts"
                  className={({ isActive }) =>
                    isActive ? "link-active" : "link"
                  }
                >
                  Auction NFT's
                </NavLink>{" "}
              </Text> */}

              {allContractDetails && (
                <Text>
                  {" "}
                  <NavLink
                    to="/mynfts"
                    className={({ isActive }) =>
                      isActive ? "link-active" : "link"
                    }
                    onClick={CheckUserHandler}
                  >
                    My NFTs
                  </NavLink>{" "}
                </Text>
              )}
            </TextWrapper>
          </LeftContainer>
          {/* <RightContainer>
            <FilterBtnWrapper>
              <ConnectWallet>Connect Wallet</ConnectWallet>
            </FilterBtnWrapper>
            <InputWrapper>
              <Input
                placeholder="Please enter keyword to"
                value={serchValue}
                onChange={(e) => {
                  setSearchValue(e.target.value);
                  e.preventDefault();
                  console.log(serchValue);
                }}
              />
              <IconWrapper>
                <ImageWrapper position="position">
                  <Icon src={Icons.SearchIcon} />
                </ImageWrapper>
              </IconWrapper>
            </InputWrapper>
          </RightContainer> */}
        </ButtonContainer>
      </Container>
    </Root>
  );
};

export default NftMarketHomepage;
